<template>
  <div>
    <h1 class="display-4">Modifier son mot de passe</h1>
    <hr />

    <form>
      <div class="form-group">
        <label for="new_password">Nouveau mot de passe</label>
        <input type="password" class="form-control" :disabled="button_disabled" id="new_password" name="new_password" placeholder="Votre nouveau mot de passe" v-model="new_password" v-validate="{ min: 8, required: true }" data-vv-as="Nouveau mot de passe">
        <div v-show="errors.has('new_password')" class="alert alert-danger mt-3">{{ errors.first('new_password') }}</div>
        <div class="alert alert-danger mt-3" v-show="error_form.new_password">
          {{ message.new_password }}
        </div>
      </div>
      <div class="form-group">
        <label for="new_password_confirm">Confirmation du mot de passe</label>
        <input type="password" class="form-control" :disabled="button_disabled" id="new_password_confirm" name="new_password_confirm" placeholder="Confirmez votre nouveau mot de passe" v-model="new_password_confirm" v-validate="{ min: 8, required: true }" data-vv-as="Confirmation du nouveau mot de passe">
        <div v-show="errors.has('new_password_confirm')" class="alert alert-danger mt-3">{{ errors.first('new_password_confirm') }}</div>
        <div class="alert alert-danger mt-3" v-show="error_form.new_password_confirm">
          {{ message.new_password_confirm }}
        </div>
      </div>
      <b-btn class="submit" type="submit" :variant="variant" @click.prevent="update">{{ message_button }}</b-btn>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import VeeValidate, { Validator } from 'vee-validate'
import veefr from 'vee-validate/dist/locale/fr'
import * as Ladda from 'ladda'

Vue.use(VueResource)
Vue.use(VeeValidate)
Validator.localize('fr', veefr)

export default {
  data () {
    return {
      button_disabled: false,
      error_form: {},
      message: {},
      message_button: 'Modifier son mot de passe',
      new_password: '',
      new_password_confirm: '',
      variant: 'primary'
    }
  },
  computed: {
    ...Vuex.mapGetters(['domain']),
    access_token () {
      return this.$route.query.access_token
    }
  },
  methods: {
    update () {
      this.error_form = {}
      this.message = {}

      if (this.new_password === this.new_password_confirm) {
        this.$validator.validateAll().then((result) => {
          console.log(result)
          if (result) {
            let l = Ladda.create(document.querySelector('.submit'))
            l.start()
            this.message_button = 'Modification du mot de passe en cours...'
            this.button_disabled = true

            this.$http.post(this.domain + '/api/ionis/reset-password?access_token=' + this.access_token, { newPassword: this.new_password }, { emulateJSON: true }).then((response) => {
              if (response.status === 204 && response.ok) {
                // this.new_password = ''
                // this.new_password_confirm = ''
                this.message_button = 'Mot de passe modifié'
                this.variant = 'success'
                l.stop()
                this.$root.$bvToast.toast('Votre mot de passe a bien été modifié', {
                  title: 'Mot de passe modifié',
                  autoHideDelay: 3000,
                  append: false,
                  variant: 'success'
                })
                // this.flash('Votre mot de passe a bien été modifié. Cliquez <a href="/#/connexion">ici</a> pour vous connecter.', 'success')
              }
            }, (response) => {

            })
          }
        })
      } else {
        this.error_form.new_password_confirm = true
        this.message.new_password_confirm = 'Les mots de passe ne correspondent pas'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue